import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AvatarModalWrapper from 'wonderbly-components/lib/AvatarModalWrapper';
import Modal from '../Modal';
import './AvatarCreationModal.scss';

const AvatarCreationModal = (props) => (
  <Modal
    default
    className={cx('AvatarCreationModal', props.className)}
    isOpen={props.isOpen}>
    <AvatarModalWrapper
      data={props.data}
      editData={props.editData}
      defaultValues={props.defaultValues}
      onHandleClose={props.onHandleClose}
      onHandleAllComplete={props.onHandleAllComplete}
      onHandleAvatarComplete={props.onHandleAvatarComplete}
      onHandleSubmitStep={props.onHandleSubmitStep}
      onHandleInputChange={props.onHandleInputChange}
      onFormatNameField={props.onFormatNameField}
    />
  </Modal>
);

AvatarCreationModal.propTypes = {
  className: PropTypes.string,
  editData: PropTypes.shape({
    index: PropTypes.number,
    avatarsCount: PropTypes.number,
  }),
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  defaultValues: PropTypes.object,
  onHandleClose: PropTypes.func,
  onHandleAllComplete: PropTypes.func,
  onHandleAvatarComplete: PropTypes.func,
  onHandleSubmitStep: PropTypes.func,
  onHandleInputChange: PropTypes.func,
  onFormatNameField: PropTypes.func,
};

export default AvatarCreationModal;
